<div class="toolbar">
    <!-- additional toolbar content / icons   -->
    <ng-content></ng-content>
</div>
